import { lightColors } from '@/plugins/colors/base/baseColorsLight'

const transparentTokensLight = {
  'transparent-tag-brand-background-default': lightColors.brand['50'],
  'transparent-tag-brand-foreground-default': lightColors.brand['300']
}

export default transparentTokensLight
